import { AdresseModel } from '../../models/AdresseModel';
import { ActionTypes } from '../actions/types';
import { emptyAdresse } from '../../layouts/tms/auftragserfassung/adresse/AdresseTypen';
import { Adresse } from '../../api';

const initialState: AdresseModel = { ...emptyAdresse };

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_ADRESSE_BY_ID:
      const adresse: AdresseModel = payload;
      return {
        ...state,
        ...adresse,
      };
    case ActionTypes.SET_ADRESSE_ID:
      return {
        ...state,
        id: payload,
      };
    case ActionTypes.SET_ADRESSE_KOPIE_ID:
      return {
        ...state,
        copyId: payload,
      };
    case ActionTypes.COPY_ADRESSE: {
      const adresse: Adresse = payload;

      const newAdresseState = copyAdresseState(adresse);
      delete newAdresseState.id;
      delete newAdresseState.fremdid;
      delete newAdresseState.fremdnummer;
      delete newAdresseState.matchcode;
      delete newAdresseState.mailTrackTrace;
      delete newAdresseState.kontakt;
      delete newAdresseState.telefon;
      newAdresseState.origin = 1;
      newAdresseState.inUebertragung = false;
      return {
        ...state,
        ...newAdresseState,
      };
    }
    case ActionTypes.SET_ADRESSE_FIELD: {
      const [value, fieldName] = [payload.value, payload.fieldName];
      return {
        ...state,
        [fieldName]: value,
      };
    }
    case ActionTypes.RESET_ADRESSERFASSUNG: {
      return {
        ...state,
        ...initialState,
      };
    }
    default:
      return state;
  }
}

const copyAdresseState = (adresse: Adresse) => {
  return {
    id: undefined,
    einmaladresse: adresse.einmaladresse,
    fremdid: undefined,
    fremdnummer: undefined,
    hausnummer: adresse.hausnummer,
    inUebertragung: false,
    kurzname: adresse.kurzname,
    land: {
      id: adresse.land?.id,
      bezeichnung: adresse.land?.bezeichnung,
      lkz: adresse.land?.lkz,
      fremdnummer: adresse.land?.fremdnummer,
      awSperre: adresse.land?.awSperre,
      mautberechnung: adresse.land?.mautberechnung,
      plzlaenge: adresse.land?.plzlaenge,
      skey: adresse.land?.skey,
    },
    lkz: adresse.land?.lkz,
    mandant: adresse.mandant,
    name: adresse.name,
    origin: 1,
    originsBezlang: 'D.ON',
    ort: adresse.ort,
    ortsteil: adresse.ortsteil,
    ortsteilname: undefined,
    plz: adresse.plz,
    strasse: adresse.strasse,
    usteuerid: undefined,
    zeile2: adresse.zeile2,
    zeile3: adresse.zeile3,
    zusatz: adresse.zusatz,
    unsichtbar: false,
    typ: undefined,
    mandantId: adresse.mandant?.id,
    matchcode: undefined,
    telefon: adresse.telefon,
    mailTrackTrace: adresse.mailTrackTrace,
    kontakt: adresse.kontakt,
  };
};
